import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Tooltip, Modal } from 'antd';
import { CalendarOutlined, NotificationOutlined, ArrowRightOutlined, InfoCircleOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

const events = [
  {
    title: "Hamare Ram",
    marathiTitle: "हमारे राम",
    time: "7:00 To 10:00 PM",
    date: "7th November 2025, Friday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/hamare_ram.jpg",
    video: "/videos/hamare-ram.mp4",
    className: "hamare-ram",
  },
  {
    title: "Vishal Mishra",
    marathiTitle: "विशाल मिश्रा",
    time: "7:00 To 10:00 PM",
    date: "8th November 2025, Saturday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/vishal.jpg",
    video: "/videos/vishal.mp4",
    className: "vishal",
  },
  {
    title: "Instrumental Fusion",
    marathiTitle: "इंस्ट्रुमेंटल फ्यूजन",
    time: "7:00 To 10:00 PM",
    date: "9th November 2025, Sunday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/fusion.jpg",
    video: "/videos/fusion.mp4",
    className: "fusion",
  },
  {
    title: "Shri.Rashtrasant Tukodoji Maharaj",
    marathiTitle: "राष्ट्रसंताची जीवनगाथा",
    time: "7:00 To 10:00 PM",
    date: "10th November 2025, Monday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/bhajan.jpg",
    video: "/videos/bhajan.mp4",
    className: "bhajan",
  },
  {
    title: "Hasya Jatra",
    marathiTitle: "हास्य जत्रा",
    time: "7:00 To 10:00 PM",
    date: "11th November 2025, Tuesday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/HasyaJatra.jpg",
    video: "/videos/hasya-jatra.mp4",
    className: "hasya-jatra",
  },
  {
    title: "Akhil Sachdeva",
    marathiTitle: "अखिल सचदेवा",
    time: "7:00 To 10:00 PM",
    date: "12th November 2025, Wednesday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/akhil.jpg",
    video: "/videos/akhil.mp4",
    className: "akhil",
  },
  {
    title: "Mitti Ke Rang",
    marathiTitle: "मिट्टी के रंग",
    time: "7:00 To 10:00 PM",
    date: "13th November 2025, Thursday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/bharati.jpg",
    video: "/videos/mitti.mp4",
    className: "bharti",
  },
  {
    title: "Rekha & Vishal Bhardwaj",
    marathiTitle: "रेखा & विशाल भारद्वाज",
    time: "7:00 To 10:00 PM",
    date: "14th November 2025, Friday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/bhardwaj.jpg",
    video: "/videos/bhardwaj.mp4",
    className: "bhardwaj",
  },
  {
    title: "Kavisammelan",
    marathiTitle: "कवि सम्मेलन",
    time: "7:00 To 10:00 PM",
    date: "15th November 2025, Saturday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/kavi.jpg",
    video: "/videos/kavi.mp4",
    className: "kavi",
  },
  {
    title: "Shreya Ghoshal",
    marathiTitle: "श्रेया घोषाल",
    time: "7:00 To 10:00 PM",
    date: "16th November 2025, Sunday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/shreya.jpg",
    video: "/videos/shreya.mp4",
    className: "shreya",
  },
  {
    title: "Shankar Mahadevan",
    marathiTitle: "शंकर महादेवन",
    time: "7:00 To 10:00 PM",
    date: "17th November 2025, Monday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/shankar.jpg",
    video: "/videos/shankar.mp4",
    className: "shankar",
  },
  {
    title: "Ajay-Atul",
    marathiTitle: "अजय-अतुल",
    time: "7:00 To 10:00 PM",
    date: "18th November 2025, Tuesday",
    venue: "Ishwar Deshmukh College Ground",
    image: "/images/movies/ajay-atul.jpg",
    video: "/videos/ajay-atul.mp4",
    className: "ajay-atul",
  },
];

const TooltipContent = ({ type, scheduleLink = "/popimage_desk.png", eventName, eventDate }) => {
  const isComingSoon = type === 'comingSoon';
  const isSoldOut = type === 'soldOut';
  const isEventOver = type === 'eventOver';

  let heading = 'Registration Not Started Yet';
  if (isComingSoon) {
    heading = '';
  } else if (isSoldOut) {
    heading = 'Registration Slots Filled';
  } else if (isEventOver) {
    heading = 'No Longer Active';
  }

  let body;
  if (isEventOver) {
    body = `The event, ${eventName ?? 'this event'}, took place on ${eventDate}. Please check our schedule for upcoming events!`;
  } else if (isSoldOut) {
    body = (
      <>
        Online registration slots for {eventName ?? 'this'} event have been filled. Explore our upcoming events.
      </>
    );
  } else if (isComingSoon) {
    body = 'Stay updated on all upcoming events and registration dates.';
  } else {
    body = 'Check our event schedule for registration dates and upcoming events.';
  }

  return (
    <div style={{
      padding: '16px',
      maxWidth: '320px',
      textAlign: 'center',
      color: 'white'
    }}>
      <h4 style={{
        fontSize: '15px',
        fontWeight: 600,
        color: '#ffffff',
        margin: '0 0 8px 0'
      }}>
        {heading}
      </h4>

      <p style={{
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.85)',
        margin: '0 0 14px 0',
        lineHeight: '1.45'
      }}>
        {body}
      </p>

      <a
        href={scheduleLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 16px',
          background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
          color: 'white',
          borderRadius: '8px',
          textDecoration: 'none',
          fontWeight: 600,
          fontSize: '14px',
          transition: 'all 0.15s',
          border: 'none',
          boxShadow: '0 6px 18px rgba(234,88,12,0.14)'
        }}
      >
        <span>View Schedule Calendar</span>
      </a>
    </div>
  );
};

const Home = () => {
  const [currentEvent, setCurrentEvent] = useState(events[0]);
  const [isTrailerOpen, setIsTrailerOpen] = useState(false);
  const [trailerSrc, setTrailerSrc] = useState("");
  const [eventsData, setEventsData] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [startDate, setStartDate] = useState();
  const [marqueeData, setMarqueeData] = useState(null);
  const [regOpen, setRegOpen] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(true);

  const [eventStatus, setEventStatus] = useState({
    soldOut: false,
    eventOver: false,
  });

  const bgVideoRef = useRef(null);
  const trailerVideoRef = useRef(null);
  const carouselInstanceRef = useRef(null);
  const clickLockedRef = useRef(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const carouselElement = document.querySelector(".carousel");

    if (carouselElement && window.M) {
      const instance = window.M.Carousel.init(carouselElement, {
        onCycleTo: (slide) => {
          const index = Array.from(carouselElement.children).indexOf(slide);
          setCurrentEvent(events[index]);
        },
      });
      carouselInstanceRef.current = instance;
      return () => {
        if (instance) instance.destroy();
      };
    }
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await fetch("/api/get/events", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "success") {
        setEventsData(data.data);
      } else {
        console.error("Error in response data:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const currentIndex = events.findIndex(
    (e) => e.title.trim().toLowerCase() === currentEvent.title.trim().toLowerCase()
  );

  const dbEvent = eventsData[currentIndex];

  useEffect(() => {
    if (bgVideoRef.current) {
      bgVideoRef.current.load();
      bgVideoRef.current.play().catch(error => {
        console.error("Autoplay failed:", error);
      });
    }

    if (trailerVideoRef.current) {
      trailerVideoRef.current.pause();
    }
  }, [currentEvent]);

  const safeChangeEvent = (event) => {
    if (clickLockedRef.current) return;
    clickLockedRef.current = true;
    setCurrentEvent(event);
    setTimeout(() => {
      clickLockedRef.current = false;
    }, 500);
  };

  const handleCarouselChange = (direction) => {
    if (!carouselInstanceRef.current) return;
    if (direction === -1) {
      carouselInstanceRef.current.prev();
    } else if (direction === 1) {
      carouselInstanceRef.current.next();
    }
  };

  const closeTrailer = () => {
    setIsTrailerOpen(false);
    if (trailerVideoRef.current) {
      trailerVideoRef.current.pause();
      trailerVideoRef.current.src = "";
      trailerVideoRef.current.load();
    }
    setTrailerSrc("");
  };

  useEffect(() => {
    fetchMarqueeData();
  }, []);

  const fetchMarqueeData = async () => {
    try {
      const response = await fetch('/api/termsconditions');
      const data = await response.json();
      if (data.marquee) {
        setMarqueeData(data.marquee);
      }
    } catch (err) {
      console.error('Error fetching marquee data:', err);
    }
  };

  const eventstartDate = (currentIndex) => {
    if (currentIndex !== -1 && eventsData[currentIndex]) {
      const event = eventsData[currentIndex];
      const regStartDateObj = dayjs(event?.regStartDate);
      const eventDateObj = dayjs(event?.eventDate);
      const now = dayjs();

      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const formattedStartDate = regStartDateObj.isValid() ? regStartDateObj.toDate().toLocaleDateString(undefined, options) : "Date not available";
      setStartDate(formattedStartDate);

      const isOver = event.active === false;
      const isSoldOut = event.eventLimit && (event.registrationCount >= event.eventLimit);

      setEventStatus({
        soldOut: isSoldOut,
        eventOver: isOver,
      });

      const isRegistrationOpen = !isSoldOut && !isOver && now?.isSameOrAfter(regStartDateObj, 'day');
      setRegOpen(isRegistrationOpen ? event?.code ?? null : null);
    } else {
      setStartDate("Date not available");
      setRegOpen(null);
      setEventStatus({ soldOut: false, eventOver: false });
    }
  };

  useEffect(() => {
    const idx = events.findIndex(
      (e) => e.title.trim().toLowerCase() === currentEvent.title.trim().toLowerCase()
    );
    if (idx !== -1) {
      eventstartDate(idx);
    }
  }, [currentEvent, eventsData]);

  const openCalendar = () => {
    setIsCalendarOpen(true);
  };

  const closeCalendar = () => {
    setIsCalendarOpen(false);
  };

  const getTooltipType = () => {
    if (eventStatus.eventOver) return 'eventOver';
    if (eventStatus.soldOut) return 'soldOut';
    if (!dbEvent) return 'comingSoon';
    return 'notStarted';
  };

  const tooltipType = getTooltipType();

  const renderModalContent = (type, event) => {
    const isEventOver = type === 'eventOver';
    const isSoldOut = type === 'soldOut';
    const isComingSoon = type === 'comingSoon';

    let heading = 'Registration Not Started Yet';
    let body = 'Check our event schedule for registration dates and upcoming events.';
    let icon = <InfoCircleOutlined />;
    let iconStyle = { color: '#ffc107' };

    if (isEventOver) {
      heading = 'Event Has ended';
      body = `This event took place on ${currentEvent.date}. Please explore our other exciting events!`;
      // icon = <CheckCircleOutlined />;
      // iconStyle = { color: '#dc3545' };
    } else if (isSoldOut) {
      heading = 'Registration Slots Filled';
      body = `Online registration slots for ${event?.eventName ?? 'this event'} have been filled. Explore our upcoming events.`;
      // icon = <CloseCircleOutlined />;
      // iconStyle = { color: '#dc3545' };
    } else if (isComingSoon) {
      heading = ``;
      body = 'We are experiencing high traffic or event details are pending. Please try again later.';
    }

    return (
      <div style={{ padding: '24px', textAlign: 'center', color: 'white' }}>
        <div style={{
          fontSize: '40px',
          marginBottom: '16px',
          ...iconStyle
        }}>
          {/* {icon} */}
        </div>
        <h4 style={{
          fontSize: '16px',
          fontWeight: 600,
          color: '#ffffff',
          margin: '0 0 12px 0'
        }}>
          {heading}
        </h4>
        <p style={{
          fontSize: '14px',
          color: 'rgba(255, 255, 255, 0.85)',
          margin: '0 0 20px 0',
          lineHeight: '1.6'
        }}>
          {body}
        </p>
        <a
          href="/popimage_mob.png"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            width: 'auto',
            padding: '8px 16px',
            background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
            color: 'white',
            borderRadius: '6px',
            textDecoration: 'none',
            fontWeight: 500,
            fontSize: '14px',
            transition: 'all 0.2s',
            border: 'none'
          }}
        >
          <span>View Schedule Calendar</span>
        </a>
      </div>
    );
  };

  const renderDisabledButton = (isForTooltipWrapper = false) => {
    let buttonText;
    if (eventStatus.eventOver) {
      buttonText = 'Event Closed';
    } else if (eventStatus.soldOut) {
      buttonText = 'Slots Filled';
    } else if (dbEvent) {
      buttonText = startDate && startDate !== "Invalid Date" && startDate !== "Date not available"
        ? `Register from ${startDate}`
        : 'Coming Soon';
    } else {
      buttonText = 'We are experiencing high traffic please try again later';
    }

    return (
      <span
        style={{
          display: 'inline-block',
          cursor: isForTooltipWrapper ? 'help' : 'default',
          position: isForTooltipWrapper ? 'relative' : 'static',
        }}
      >
        <button
          className="button registration-button disabled"
          disabled={true}
          style={{
            cursor: 'help',
            position: 'relative',
            pointerEvents: 'none'
          }}
        >
          {buttonText}
          <InfoCircleOutlined
            style={{
              marginLeft: '8px',
              fontSize: '14px',
              opacity: 0.8
            }}
          />
        </button>
      </span>
    );
  };

  return (
    <div>
      {marqueeData && marqueeData.isActive && (
        <div
          className="marquee-container"
          style={{
            background: marqueeData.backgroundColor,
            color: marqueeData.textColor
          }}
        >
          <div className="marquee-content">
            <span>{marqueeData.marqueeText}</span>
          </div>
        </div>
      )}

      <Header />

      <video id="background-video" ref={bgVideoRef} autoPlay loop muted>
        <source src={currentEvent.video} type="video/mp4" />
      </video>

      <div className="banner">
        <div className={`content ${currentEvent.className} active`}>
          <h2 className="movie-title">
            {currentEvent.title}{" "}
            <span className="mar-title">{currentEvent.marathiTitle}</span>
          </h2>
          <ul className="program-details">
            <li>
              <i className="fa fa-clock-o" aria-hidden="true"></i>
              {currentEvent.time}
            </li>
            <li>
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {currentEvent.date}
            </li>
            <li>
              <i className="fa fa-map-marker" aria-hidden="true"></i>
              {currentEvent.venue}
            </li>
          </ul>

          <div className="button-group">
            {regOpen ? (
              <a href={`/${regOpen}`} className="button registration-button">
                Click here to register
              </a>
            ) : (
              isMobile ? (
                <>
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowModal(true);
                    }}
                    style={{ display: 'inline-block', cursor: 'pointer' }}
                  >
                    <button className="button registration-button disabled" disabled={true} style={{ cursor: 'help', pointerEvents: 'none' }}>
                      {eventStatus.eventOver ? (
                        <>Event Closed <CheckCircleOutlined style={{ marginLeft: '8px', opacity: 0.8 }} /></>
                      ) : eventStatus.soldOut ? (
                        <>Slots Filled <InfoCircleOutlined style={{ marginLeft: '8px', opacity: 0.8 }} /></>
                      ) : (
                        startDate && startDate !== "Invalid Date" && startDate !== "Date not available"
                          ? <>Register from {startDate} <InfoCircleOutlined style={{ marginLeft: '8px', opacity: 0.8 }} /></>
                          : <>Coming Soon <InfoCircleOutlined style={{ marginLeft: '8px', opacity: 0.8 }} /></>
                      )}
                    </button>
                  </span>

                  <Modal
                    open={showModal}
                    onCancel={() => setShowModal(false)}
                    footer={null}
                    centered
                    closeIcon={
                      <div style={{
                        color: 'white',
                        fontSize: '16px',
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        cursor: 'pointer'
                      }}>
                        &times;
                      </div>
                    }
                    width={320}
                    styles={{
                      mask: { background: 'rgba(0, 0, 0, 0.75)' },
                      content: {
                        backgroundColor: '#1f2937',
                        borderRadius: '12px',
                        padding: '4px',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)'
                      },
                      body: {
                        padding: '0',
                        textAlign: 'center',
                        color: 'white',
                      }
                    }}
                  >
                    {renderModalContent(tooltipType, dbEvent)}
                  </Modal>
                </>
              ) : (
                <Tooltip
                  title={<TooltipContent
                    type={tooltipType}
                    eventName={dbEvent?.eventName}
                    eventDate={currentEvent.date}
                  />}
                  placement="bottom"
                  trigger={['hover', 'click']}
                  open={showTooltip}
                  onOpenChange={setShowTooltip}
                  overlayStyle={{ maxWidth: '320px' }}
                  arrow={{ pointAtCenter: true }}
                >
                  {renderDisabledButton(true)}
                </Tooltip>
              )
            )}
          </div>

          <p className="instructions">
          </p>
        </div>

        <div className="carousel-box" style={{ position: 'relative' }}>
          <div className="carousel">
            {events.map((event, index) => (
              <div
                key={index}
                className="carousel-item"
                onClick={() => safeChangeEvent(event)}
              >
                <img src={event.image} alt={event.title} />
              </div>
            ))}
          </div>
          <button
            className="carousel-button left"
            onClick={() => handleCarouselChange(-1)}
            style={{
              position: 'absolute',
              top: '50%',
              left: '10px',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              border: 'none',
              cursor: 'pointer',
              padding: '10px',
              zIndex: 10,
              borderRadius: '5px',
            }}
          >
            &#10094;
          </button>
          <button
            className="carousel-button right"
            onClick={() => handleCarouselChange(1)}
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              border: 'none',
              cursor: 'pointer',
              padding: '10px',
              zIndex: 10,
              borderRadius: '5px',
            }}
          >
            &#10095;
          </button>
        </div>
      </div>

      {isCalendarOpen && (
        <div
          className="calendar-popup"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: window.innerWidth <= 768 ? '10px' : '20px',
          }}
          onClick={closeCalendar}
        >
          <div
            style={{
              position: 'relative',
              display: 'inline-block',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <picture>
              <source media="(max-width: 768px)" srcSet="/popimage_mob.png" />
              <img
                src="/popimage_desk.png"
                alt="Event Calendar"
                style={{
                  maxWidth: window.innerWidth <= 768 ? '95vw' : '90vw',
                  maxHeight: window.innerWidth <= 768 ? '80vh' : '85vh',
                  objectFit: 'contain',
                  display: 'block',
                  borderRadius: '5px',
                }}
              />
            </picture>

            <button
              onClick={closeCalendar}
              style={{
                position: 'absolute',
                top: window.innerWidth <= 768 ? '10px' : '15px',
                right: window.innerWidth <= 768 ? '10px' : '15px',
                width: window.innerWidth <= 768 ? '30px' : '35px',
                height: window.innerWidth <= 768 ? '30px' : '35px',
                backgroundColor: 'white',
                border: 'none',
                cursor: 'pointer',
                fontSize: window.innerWidth <= 768 ? '22px' : '26px',
                color: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1001,
                borderRadius: '4px',
                fontWeight: 'bold',
              }}
            >
              ×
            </button>

            <button
              onClick={closeCalendar}
              style={{
                position: 'absolute',
                bottom: window.innerWidth <= 768 ? '10px' : '15px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'black',
                border: '2px solid #000',
                padding: window.innerWidth <= 768 ? '8px 16px' : '10px 24px',
                cursor: 'pointer',
                fontSize: window.innerWidth <= 768 ? '12px' : '16px',
                fontWeight: '700',
                borderRadius: '6px',
                zIndex: 1001,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                minWidth: window.innerWidth <= 768 ? '120px' : '140px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                transition: 'all 0.3s ease',
                whiteSpace: 'nowrap',
                fontFamily: 'Arial, sans-serif'
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {isTrailerOpen && (
        <div className="trailer active">
          <video ref={trailerVideoRef} src={trailerSrc} controls></video>
          <img
            className="close"
            src="/images/close.png"
            alt="close"
            onClick={closeTrailer}
          />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Home;

